import { useTranslation } from "react-i18next";
import CompetitorCard from "../../competitorAnalysisCard";

export const PlanCompetitorAnalysis = ({ competitorResults }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Suggested Questions */}
      {competitorResults &&
        competitorResults?.general?.questions.length > 0 && (
          <>
            <p className="text-white text-xl mt-6 mb-4 font-bold">
              {t("Suggested-questions", "Suggested questions")} {"(PAA)"}
            </p>

            <div className="flex flex-col gap-3  flex-wrap ">
              {competitorResults?.general?.questions?.map((item) => {
                return (
                  <div className="bg-slate-100 rounded font-semibold px-3 py-2 text-sm text-black">
                    {" "}
                    {item}{" "}
                  </div>
                );
              })}
            </div>
          </>
        )}
      {competitorResults && competitorResults?.analysis?.length > 0 && (
        <>
          <p className="text-white text-xl mt-6 mb-4 font-bold">
            {t("Competition", "Competition")}
          </p>
        </>
      )}
      {competitorResults &&
        competitorResults?.analysis?.map((item, index) => {
          return (
            <CompetitorCard
              type={"plan"}
              index={index}
              general={competitorResults.general}
              content={competitorResults.contents[index]}
              analysis={item}
              seoRequest={competitorResults.seo_request}
              url={competitorResults.contents[index].url}
            ></CompetitorCard>
          );
        })}
    </>
  );
};
